import './polyfill';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import setup from './config/setup';
import { AppProvider } from 'context/AppContext';
import { AuthProvider } from 'context/AuthContext';
import { AuthGuardProvider } from 'context/AuthGuardContext';
import { GoogleAnalyticsProvider } from './utils/googleAnalytics';
import { PageScroll } from './components';
import { unregister } from './registerServiceWorker';
import { SegmentProvider } from 'context/SegmentContext';
import { LogRocketProvider } from 'context/LogRocketProvider';
// import registerServiceWorker from './registerServiceWorker';

// disable ServiceWorker

setup();

const root = createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AppProvider>
      <GoogleAnalyticsProvider>
        <AuthGuardProvider>
          <AuthProvider>
            <LogRocketProvider>
              <SegmentProvider>
                <PageScroll.Provider>
                  <App />
                </PageScroll.Provider>
              </SegmentProvider>
            </LogRocketProvider>
          </AuthProvider>
        </AuthGuardProvider>
      </GoogleAnalyticsProvider>
    </AppProvider>
  </BrowserRouter>
);

unregister();
// disable ServiceWorker
// registerServiceWorker();
